module.exports = __webpack_public_path__ + "img/2-min.9b9afdf3.jpg";